import { Space } from 'antd';
import styled from 'styled-components';
import { DueDate } from 'components/atoms/due-date';
import { BodyShort01 } from 'components/styles';

export const Container = styled(Space).attrs({
  align: 'center',
  size: 4,
})`
  width: 100%;
  height: var(--spacing-06);
  margin: var(--spacing-03) auto;
`;

export const StyledDueDate = styled(DueDate)`
  ${BodyShort01};
  font-size: var(--font-size-sm);
`;

export const IconContainer = styled.div`
  width: var(--spacing-07);
`;
